import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";
import store from "../../store/index.js";
import { i18n } from "../../main";

Vue.prototype.$loja_gerenciar = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      // informacoes gerais
      modalConfirm: false,
      lojas: [],
      filtros: [],
      regionais: [],
      filter: {
        nome: "",
        cpf: "",
        cnpj: "",
        status: "",
        regional: "",
        tipoPessoa: "",
        dataInicio: "",
        dataFim: "",
      },
      lista_forma_pagamento: [],
      lista_forma_pagamento_loja: [],
      sequenciador: "",
      bandeirasPgto: [],
      lojaAddOrEdit: "new",
      cadastro: {
        tipoFormaPagamento: [
          { key: "DEFAULT", value: "Padrão" },
          { key: "CUSTOM", value: "Personalizada" },
        ],
        tipoComissaoWeb: [],
        tipoComissaoPos: [],
        tipoTaxaPacote: [
          { key: "PERCENTUAL", value: "Percentual" },
          { key: "VALOR", value: "Valor" },
        ],
        tipoTaxaCortesia: [
          { key: "PERCENTUAL", value: "Percentual" },
          { key: "VALOR", value: "Valor" },
        ],
        // tipoTaxaWeb: [
        //   { key: "PERCENTUAL", value: "Percentual" },
        //   { key: "VALOR", value: "Valor" },
        // ],
        // tipoTaxaPos: [
        //   { key: "PERCENTUAL", value: "Percentual" },
        //   { key: "VALOR", value: "Valor" },
        // ],
        loading: false,
        lojas_loading: false,
        id_loja: "",
        new_idloja: null,
        id_tema: "",
        dados_cadastrais: {
          pessoa: "JURIDICA",
          razao_social: "",
          cnpj: "",
          cep: "",
          logradouro: "",
          bairro: "",
          estado: "",
          cidade: "",
          pais: "",
          complemento: "",
          // pessoa fisica
          email: "",
          nome: "",
          cpf: "",
          rg: "",
          rg_orgao: "",
          celular: "",
          // pessoa juridica
          // representante_email: '',
          // representante_nome: '',
          // representante_cpf: '',
          // representante_rg: '',
          // representante_rg_orgao: '',
          // representante_celular: '',

          segmento: "",
          regional: "",
          agente_vinculado: "",
          status: "",
          nome_loja: "",
          slug_loja: "",
          tipo_slug: "DEFAULT",
          idloja_neo: "",
          error: {
            razao_social: [],
            cnpj: [],
            cep: [],
            logradouro: [],
            bairro: [],
            pais: [],
            estado: [],
            cidade: [],
            email: "",
            nome: [],
            cpf: [],
            rg: [],
            rg_orgao: [],
            celular: [],
            representante_email: [],
            representante_nome: [],
            representante_cpf: [],
            representante_rg: [],
            representante_rg_orgao: [],
            representante_celular: [],
            segmento: [],
            regional: [],
            agente_vinculado: [],
            status: [],
            nome_loja: [],
            slug_loja: [],
          },
        },
        comissao_antecipacao: {
          // tipoComissaoWeb: "CONVENIENCIA",
          // tipoComissaoPos: "COMISSAO",
          tipoTaxaPacote: "VALOR",
          tipoTaxaCortesia: "VALOR",
          // tipoTaxaWeb: "PERCENTUAL",
          // tipoTaxaPos: "PERCENTUAL",
          // valor_taxa_web: "",
          // percentual_taxa_web: "10",
          // valor_taxa_pos: "",
          // percentual_taxa_pos: "7.4",
          // onProcessamento: false,
          aplicar_taxas_pacote: 0,
          aplicar_taxas_gratuidade: 0,
          aplicar_taxas_cortesia: 0,
          // taxa_processamento: "",
          comissao: "7.4",
          porcentagem_customizada: "",
          antecipacao: "",
          taxa_personalizada: "",
          dias_antecipacao: "",
          taxa_mes: "",
          taxaPacote: "0",
          taxaCortesia: "0",
          taxaGratuidade: "0",
          observacoes: "",
          error: {
            comissao: [],
            porcentagem_customizada: [],
            antecipacao: [],
            taxa_personalizada: [],
            dias_antecipacao: [],
            taxa_mes: [],
          },
        },
        dados_bancarios: {
          tipo_forma_pag: "DEFAULT",
          nome_titular: "",
          banco: "",
          agencia: "",
          tipo_conta: "CORRENTE",
          numero_conta: "",
          digito_conta: "",
          forma_pag: [],
          bandeiras: [],
          error: {
            nome_titular: [],
            banco: [],
            agencia: [],
            tipo_conta: [],
            numero_conta: [],
            digito_conta: [],
            forma_pag: [],
          },
        },
        documentos: {
          documento: "",
          documento_upload: { doc: null },
          loading_documento: false,
          documento_array_pj: [],
          documento_array_pf: [],
          error: {
            documento: [],
          },
        },
        // contratos: {
        //     template: ''
        // },
        tema: {
          cor_primaria: "#2D1A4C",
          cor_secundaria: "#2D1A4C",
          marketing_imply_ativo: false,
          logotipo: { imagem: null, have: false },
          imagem: "",
          imagem_upload: { imagem: null },
          loading_imagem: false,
          logotipo_pos: { imagem: null, have: false },
          imagem_pos: "",
          imagem_upload_pos: { imagem_pos: null },
          loading_imagem_pos: false,
          logotipo_ingresso: { imagem: null, have: false },
          imagem_ingresso: "",
          loading_imagem_ingresso: false,
          banners_array: [],
          texto_banner: "",
          texto_banner_en: "",
          texto_banner_es: "",
          banner_link: "",
          tem_traducao: false,
          error: {
            imagem: [],
            imagem_logo: [],
            logotipo_pos: [],
            logotipo_ingresso: [],
            logotipo: [],
          },
        },
        configuracoes_rede: {
          rede_vendas: "COMPARTILHADA",
          validar_cpf: 1,
          rede_privada: [],
          rede_compartilhada: [],
          perfis_pdv: "",
          canal_venda_descontos: {
            MARKETPLACE: "",
            PDV_POS: "",
            ECOMMERCE: "",
          },
        },
        configuracoes_adicionais: {
          configsPlusAddEdit: "new",
          perguntas_frequentes: [],
          redes_sociais: [],
          contato: [],
          politicas: [],
          contato_sac: "",
          contato_email: "",
          error: {
            contato_email: [],
          },
        },
        acesso: {
          circus: false,
          url_circus: "",
          idevento_default: "",
          token_circus: "",
          loading_sync: false,
          loading_sync_all: false,
          error: {
            circus: [],
            url_circus: [],
            idevento_default: [],
            token_circus: [],
          },
        },
        cashless: {
          url_cashless: "",
          token_cashless: "",
        },
      },
      // configs plus
      text: "",
      funcao: "",
      indexValue: "",
      question: {
        ordem: "",
        pergunta_pt_BR: "",
        pergunta_en_US: "",
        pergunta_es_ES: "",
        resposta_pt_BR: "",
        resposta_en_US: "",
        resposta_es_ES: "",
        tem_traducao: false,
      },
      questionIdx: "",
      social_media: {
        ordem: "",
        descricao: "",
        valor: "",
      },
      social_mediaIdx: "",
      contato: {
        ordem: "",
        descricao: "",
        texto: "",
      },
      contatoIdx: "",
      politica: {
        descricao_pt_BR: "",
        descricao_en_US: "",
        descricao_es_ES: "",
        texto_pt_BR: "",
        texto_en_US: "",
        texto_es_ES: "",
        tem_traducao: false,
      },
      politicaIdx: "",
      // modais de visualização
      visualizarImagem: "",
      visualizarPDF: "",
      tipo_imagem: [
        { key: "Banner Rodapé", value: "banner_rodape", show: true },
      ],
      tipo_docs_pf: [
        {
          key: "Comprovante de Endereço ",
          value: "pdf_comprovante_endereco",
          show: true,
        },
        {
          key: "Documento (RG, CPF ou CNH)",
          value: "pdf_documento",
          show: true,
        },
        {
          key: "Proposta Comercial ",
          value: "pdf_proposta_comercial",
          show: true,
        },
      ],
      tipo_docs_pj: [
        {
          key: "Comprovante de Endereço ",
          value: "pdf_comprovante_endereco",
          show: true,
        },
        { key: "Contrato Social", value: "pdf_contrato_social", show: true },
        { key: "Procuração", value: "pdf_procuracao", show: true },
        {
          key: "Proposta Comercial ",
          value: "pdf_proposta_comercial",
          show: true,
        },
      ],
      indexImageOrDoc: "",
      valueImageOrDoc: "",
      formaPag: {
        formas_pgto_AddEdit: "new",
        add_formas: false,
        formas_pgto_loading: false,
        formas_pgto_button_loading: false,
        filter_loading: false,
        cadastro: {
          idforma_pag: "",
          ordem: "",
          descricao: "",
          status: "",
          juros: "",
          parcelas: "",
          tipo: "",
          error: {
            ordem: [],
            descricao: [],
            status: [],
            tipo: [],
          },
        },
        formas_pagamento: [],
        filtros: [],
        status: [
          { text: "ATIVO", value: "ATIVO" },
          { text: "INATIVO", value: "INATIVO" },
        ],
        modosPgto: [],
        text: "",
        funcao: "",
      },
      produtor: {
        text: "",
      },
    };
  },
  methods: {
    // getTipoTaxas() {
    //   this.$axios
    //     .get(this.ENDPOINTS.LISTAR_TIPOS_TAXAS + "array")
    //     .then(response => {
    //       this.cadastro.tipoComissaoWeb = response;
    //       this.cadastro.tipoComissaoPos = response;
    //     });
    // },
    /**
     * @description Função que lista lojas
     */
    getAllLojas() {
      this.cadastro.lojas_loading = true;
      this.$axios.post(this.ENDPOINTS.LISTAR_LOJAS).then(response => {
        if (response) {
          this.lojas = response;
          this.cadastro.lojas_loading = false;
        }
      });
    },

    getLoja(idloja) {
      let filtros = [
        {
          campo: "loja.idloja",
          tipo: "string",
          valor: idloja,
        },
      ];
      this.$axios
        .post(this.ENDPOINTS.LISTAR_LOJAS, JSON.stringify({ filtros }))
        .then(response => {
          if (response) {
            let dados = response[0];
            this.cadastro.id_loja = dados.idloja;
            this.cadastro.id_tema = dados.idtema;

            // DADOS CADASTRAIS
            this.cadastro.dados_cadastrais.pessoa = dados.tipo_pessoa
              ? dados.tipo_pessoa
              : "JURIDICA";
            this.cadastro.dados_cadastrais.razao_social = dados.razao_social
              ? dados.razao_social
              : "";
            this.cadastro.dados_cadastrais.cnpj = dados.cnpj ? dados.cnpj : "";
            this.cadastro.dados_cadastrais.pais = dados.end_pais
              ? dados.end_pais
              : "";
            this.cadastro.dados_cadastrais.cep = dados.end_cep
              ? dados.end_cep
              : "";
            this.cadastro.dados_cadastrais.logradouro = dados.end_logradouro
              ? dados.end_logradouro
              : "";
            this.cadastro.dados_cadastrais.numero = dados.end_numero
              ? dados.end_numero
              : "";
            this.cadastro.dados_cadastrais.complemento = dados.end_complemento
              ? dados.end_complemento
              : "";
            this.cadastro.dados_cadastrais.bairro = dados.end_bairro
              ? dados.end_bairro
              : "";
            this.cadastro.dados_cadastrais.estado = dados.end_estado
              ? dados.end_estado
              : "";
            this.cadastro.dados_cadastrais.cidade = dados.end_cidade
              ? dados.end_cidade
              : "";
            this.cadastro.dados_cadastrais.idloja_neo = dados.idloja_neo
              ? dados.idloja_neo
              : "";

            if (dados.tipo_pessoa == "JURIDICA") {
              // PESSOA JURIDICA
              this.cadastro.dados_cadastrais.nome = dados.representante_nome
                ? dados.representante_nome
                : "";
              this.cadastro.dados_cadastrais.email = dados.representante_email
                ? dados.representante_email
                : "";
              this.cadastro.dados_cadastrais.cpf = dados.representante_cpf
                ? dados.representante_cpf
                : "";
              this.cadastro.dados_cadastrais.rg = dados.representante_rg
                ? dados.representante_rg
                : "";
              this.cadastro.dados_cadastrais.rg_orgao =
                dados.representante_rg_orgao
                  ? dados.representante_rg_orgao
                  : "";

              // DOCUMENTOS
              let documento = [];

              if (dados.pdf_documento) {
                documento.push({ pdf_documento: dados.pdf_documento });
                this.cadastro.documentos.documento_array_pj = documento;
              }
              if (dados.pdf_contrato_social) {
                documento.push({
                  pdf_contrato_social: dados.pdf_contrato_social,
                });
                this.$loja_gerenciar.cadastro.documentos.documento_array_pj =
                  documento;
              }

              if (dados.pdf_comprovante_endereco) {
                documento.push({
                  pdf_comprovante_endereco: dados.pdf_comprovante_endereco,
                });
                this.cadastro.documentos.documento_array_pj = documento;
              }

              if (dados.pdf_procuracao) {
                documento.push({ pdf_procuracao: dados.pdf_procuracao });
                this.cadastro.documentos.documento_array_pj = documento;
              }
              if (dados.pdf_proposta_comercial) {
                documento.push({
                  pdf_proposta_comercial: dados.pdf_proposta_comercial,
                });
                this.cadastro.documentos.documento_array_pj = documento;
              }
            } else {
              // PESSOA FISICA
              this.cadastro.dados_cadastrais.nome = dados.nome
                ? dados.nome
                : "";
              this.cadastro.dados_cadastrais.cpf = dados.cpf ? dados.cpf : "";
              this.cadastro.dados_cadastrais.rg = dados.rg ? dados.rg : "";
              this.cadastro.dados_cadastrais.rg_orgao = dados.rg_orgao
                ? dados.rg_orgao
                : "";
              this.cadastro.dados_cadastrais.email = dados.email
                ? dados.email
                : "";

              // DOCUMENTOS
              let documento = [];

              if (dados.pdf_documento) {
                documento.push({ pdf_documento: dados.pdf_documento });
                this.cadastro.documentos.documento_array_pf = documento;
              }

              if (dados.pdf_contrato_social) {
                documento.push({
                  pdf_contrato_social: dados.pdf_contrato_social,
                });
                this.cadastro.documentos.documento_array_pf = documento;
              }

              if (dados.pdf_comprovante_endereco) {
                documento.push({
                  pdf_comprovante_endereco: dados.pdf_comprovante_endereco,
                });
                this.cadastro.documentos.documento_array_pf = documento;
              }

              if (dados.pdf_procuracao) {
                documento.push({ pdf_procuracao: dados.pdf_procuracao });
                this.cadastro.documentos.documento_array_pf = documento;
              }

              if (dados.pdf_proposta_comercial) {
                documento.push({
                  pdf_proposta_comercial: dados.pdf_proposta_comercial,
                });
                this.cadastro.documentos.documento_array_pf = documento;
              }
            }

            this.cadastro.dados_cadastrais.celular = dados.celular
              ? dados.celular
              : "";

            this.cadastro.dados_cadastrais.segmento = dados.idsegmento
              ? dados.idsegmento
              : "";
            this.cadastro.dados_cadastrais.regional = dados.idregional
              ? dados.idregional
              : "";
            this.cadastro.dados_cadastrais.agente_vinculado = dados.idagente
              ? dados.idagente
              : "";
            this.cadastro.dados_cadastrais.status = dados.status
              ? dados.status
              : "";
            this.cadastro.dados_cadastrais.nome_loja = dados.nome_loja
              ? dados.nome_loja
              : "";
            this.cadastro.dados_cadastrais.slug_loja = dados.slug
              ? dados.slug
              : "";
            this.cadastro.dados_cadastrais.tipo_slug = dados.tipo_slug
              ? dados.tipo_slug
              : "DEFAULT";
            // COMISSÃO E ANTECIPAÇÃO

            // DADOS COMISSAO WEB
            // if (dados.tipo_taxa_web === "CONVENIENCIA") {
            //   this.cadastro.comissao_antecipacao.tipoComissaoWeb =
            //     "CONVENIENCIA";
            // } else {
            //   this.cadastro.comissao_antecipacao.tipoComissaoWeb = "COMISSAO";
            // }

            // if (dados.tipo_taxa_web === "COMISSAO") {
            //   if (dados.comissao_web > 0) {
            //     this.cadastro.comissao_antecipacao.tipoTaxaWeb = "VALOR";
            //     this.cadastro.comissao_antecipacao.valor_taxa_web =
            //       dados.comissao_web;
            //   } else {
            //     this.cadastro.comissao_antecipacao.tipoTaxaWeb = "PERCENTUAL";
            //     this.cadastro.comissao_antecipacao.percentual_taxa_web =
            //       dados.comissao_porcentagem_custom_web;
            //   }
            // }

            // if (dados.tipo_taxa_web === "CONVENIENCIA") {
            //   if (dados.taxa_conveniencia_web > 0) {
            //     this.cadastro.comissao_antecipacao.tipoTaxaWeb = "VALOR";
            //     this.cadastro.comissao_antecipacao.valor_taxa_web =
            //       dados.taxa_conveniencia_web;
            //   } else {
            //     this.cadastro.comissao_antecipacao.tipoTaxaWeb = "PERCENTUAL";
            //     this.cadastro.comissao_antecipacao.percentual_taxa_web =
            //       dados.taxa_conveniencia_porcentagem_custom_web;
            //   }
            // }

            // // DADOS COMISSAO POS
            // if (dados.tipo_taxa_pos === "CONVENIENCIA") {
            //   this.cadastro.comissao_antecipacao.tipoComissaoPos =
            //     "CONVENIENCIA";
            // } else {
            //   this.cadastro.comissao_antecipacao.tipoComissaoPos = "COMISSAO";
            // }

            // if (dados.tipo_taxa_pos === "COMISSAO") {
            //   if (dados.comissao_pos > 0) {
            //     this.cadastro.comissao_antecipacao.tipoTaxaPos = "VALOR";
            //     this.cadastro.comissao_antecipacao.valor_taxa_pos =
            //       dados.comissao_pos;
            //   } else {
            //     this.cadastro.comissao_antecipacao.tipoTaxaPos = "PERCENTUAL";
            //     this.cadastro.comissao_antecipacao.percentual_taxa_pos =
            //       dados.comissao_porcentagem_custom_pos;
            //   }
            // }

            // if (dados.tipo_taxa_pos === "CONVENIENCIA") {
            //   if (dados.taxa_conveniencia_pos > 0) {
            //     this.cadastro.comissao_antecipacao.tipoTaxaPos = "VALOR";
            //     this.cadastro.comissao_antecipacao.valor_taxa_pos =
            //       dados.taxa_conveniencia_pos;
            //   } else {
            //     this.cadastro.comissao_antecipacao.tipoTaxaPos = "PERCENTUAL";
            //     this.cadastro.comissao_antecipacao.percentual_taxa_pos =
            //       dados.taxa_conveniencia_porcentagem_custom_pos;
            //   }
            // }

            // this.cadastro.comissao_antecipacao.taxa_processamento =
            //   dados.taxa_processamento ? dados.taxa_processamento : "0";
            this.cadastro.comissao_antecipacao.antecipacao =
              dados.antecipacao_taxa ? dados.antecipacao_taxa : "";
            this.cadastro.comissao_antecipacao.taxa_personalizada =
              dados.antecipacao_taxa_custom
                ? dados.antecipacao_taxa_custom
                : "";
            this.cadastro.comissao_antecipacao.dias_antecipacao =
              dados.antecipacao_dias ? dados.antecipacao_dias : "";
            this.cadastro.comissao_antecipacao.taxa_mes = dados.antecipacao_taxa
              ? dados.antecipacao_taxa
              : "";
            this.cadastro.comissao_antecipacao.tipoTaxaCortesia =
              dados.tipo_taxa_cortesia;
            this.cadastro.comissao_antecipacao.tipoTaxaPacote =
              dados.tipo_taxa_pacote;
            this.cadastro.comissao_antecipacao.taxaCortesia =
              dados.taxa_cortesia;
            this.cadastro.comissao_antecipacao.taxaGratuidade =
              dados.taxa_gratuidade;
            this.cadastro.comissao_antecipacao.taxaPacote = dados.taxa_pacote;
            this.cadastro.comissao_antecipacao.aplicar_taxas_pacote =
              dados.aplica_taxa_pacote;
            this.cadastro.comissao_antecipacao.aplicar_taxas_gratuidade =
              dados.aplica_taxa_gratuidade;
            this.cadastro.comissao_antecipacao.aplicar_taxas_cortesia =
              dados.aplica_taxa_cortesia;
            this.cadastro.comissao_antecipacao.observacoes = dados.observacoes
              ? dados.observacoes
              : "";

            // DADOS BANCARIOS
            this.cadastro.dados_bancarios.tipo_forma_pag = dados.nidforma_pag
              ? "CUSTOM"
              : "DEFAULT";
            this.cadastro.dados_bancarios.nome_titular = dados.nome_titular
              ? dados.nome_titular
              : "";
            this.cadastro.dados_bancarios.banco = dados.banco
              ? dados.banco
              : "";
            this.cadastro.dados_bancarios.agencia = dados.agencia
              ? dados.agencia
              : "";
            this.cadastro.dados_bancarios.tipo_conta = dados.tipo_conta
              ? dados.tipo_conta
              : "CORRENTE";
            this.cadastro.dados_bancarios.numero_conta = dados.numero_conta
              ? dados.numero_conta
              : "";
            this.cadastro.dados_bancarios.digito_conta =
              dados.digito_conta || dados.digito_conta === 0
                ? dados.digito_conta
                : "";
            if (this.cadastro.dados_bancarios.tipo_forma_pag === "CUSTOM") {
              this.cadastro.dados_bancarios.forma_pag = dados.nidforma_pag
                ? dados.nidforma_pag.split(";")
                : [];
            } else {
              this.cadastro.dados_bancarios.forma_pag =
                dados.nidforma_pag_default
                  ? dados.nidforma_pag_default.split(";")
                  : [];
            }
            this.cadastro.dados_bancarios.bandeiras =
              dados.bandeiras.split(";");
            this.cadastro.dados_bancarios.loja = dados.sequenciador;

            // CONTRATOS
            // this.$loja_gerenciar.cadastro.contratos.template = ''

            // TEMA
            this.cadastro.tema.cor_primaria = dados.tema_cor_primaria
              ? dados.tema_cor_primaria
              : "#2D1A4C";
            this.cadastro.tema.banner_link = dados.tema_banner_link
              ? dados.tema_banner_link
              : "";
            this.cadastro.tema.cor_secundaria = dados.tema_cor_secundaria
              ? dados.tema_cor_secundaria
              : "#2D1A4C";
            this.cadastro.tema.marketing_imply_ativo =
              dados.marketing_imply_ativo ? dados.marketing_imply_ativo : false;

            if (dados.tema_logotipo) {
              this.cadastro.tema.logotipo.imagem = dados.tema_logotipo;
              this.cadastro.tema.logotipo.have = true;
            }

            if (dados.tema_logotipo_pos) {
              this.cadastro.tema.logotipo_pos.imagem = dados.tema_logotipo_pos;
              this.cadastro.tema.logotipo_pos.have = true;
            }
            if (dados.tema_logotipo_ingresso) {
              this.cadastro.tema.logotipo_ingresso.imagem =
                dados.tema_logotipo_ingresso;
              this.cadastro.tema.logotipo_ingresso.have = true;
            }

            if (dados.tema_banners) {
              const arrayOfObj = Object.entries(dados.tema_banners).map(e => ({
                [e[0]]: e[1],
              }));

              this.cadastro.tema.banners_array = arrayOfObj;
            }

            this.cadastro.tema.tem_traducao = dados.tema_banner_texto_traducao
              ? dados.tema_banner_texto_traducao
              : false;

            if (dados.tema_banner_texto.indexOf("<pt_BR>") > -1) {
              this.cadastro.tema.texto_banner = dados.tema_banner_texto_traducao
                ? dados.tema_banner_texto.substring(
                    dados.tema_banner_texto.indexOf("<pt_BR>") + 7,
                    dados.tema_banner_texto.indexOf("</pt_BR>")
                  )
                : "";
              this.cadastro.tema.texto_banner_en =
                dados.tema_banner_texto_traducao
                  ? dados.tema_banner_texto.substring(
                      dados.tema_banner_texto.indexOf("<en_US>") + 7,
                      dados.tema_banner_texto.indexOf("</en_US>")
                    )
                  : "";
              this.cadastro.tema.texto_banner_es =
                dados.tema_banner_texto_traducao
                  ? dados.tema_banner_texto.substring(
                      dados.tema_banner_texto.indexOf("<es_ES>") + 7,
                      dados.tema_banner_texto.indexOf("</es_ES>")
                    )
                  : "";
            } else {
              this.cadastro.tema.texto_banner = dados.tema_banner_texto;
            }

            // CONFIGURAÇÕES DE REDE
            this.cadastro.configuracoes_rede.rede_vendas = dados.rede_vendas
              ? dados.rede_vendas
              : "PRIVADA";
            this.cadastro.configuracoes_rede.rede_privada =
              dados.canal_venda[0] === "" ? [] : dados.canal_venda;
            this.cadastro.configuracoes_rede.rede_compartilhada =
              dados.canal_venda[0] === "" ? [] : dados.canal_venda;
            this.cadastro.configuracoes_rede.canal_venda_descontos.PDV_POS =
              dados.canal_venda_descontos.PDV_POS;
            this.cadastro.configuracoes_rede.canal_venda_descontos.ECOMMERCE =
              dados.canal_venda_descontos.ECOMMERCE;
            this.cadastro.configuracoes_rede.canal_venda_descontos.MARKETPLACE =
              dados.canal_venda_descontos.MARKETPLACE;
            this.cadastro.configuracoes_rede.validar_cpf = dados.validar_cpf
              ? 1
              : dados.validar_cpf;

            // this.$loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada = [],
            // this.$loja_gerenciar.cadastro.configuracoes_rede.perfis_pdv = ''

            // CONFIGURAÇÕES ADICIONAIS
            if (this.lojaAddOrEdit && dados.faq != undefined) {
              this.cadastro.configuracoes_adicionais.perguntas_frequentes =
                dados.faq;
            }
            if (this.lojaAddOrEdit && dados.redes_sociais != undefined) {
              this.cadastro.configuracoes_adicionais.redes_sociais =
                dados.redes_sociais;
            }
            if (this.lojaAddOrEdit && dados.contato != undefined) {
              this.cadastro.configuracoes_adicionais.contato = dados.contato;
            }
            if (this.lojaAddOrEdit && dados.politicas != undefined) {
              this.cadastro.configuracoes_adicionais.politicas =
                dados.politicas;
            }
            if (this.lojaAddOrEdit && dados.contato_sac) {
              this.cadastro.configuracoes_adicionais.contato_sac =
                dados.contato_sac;
            }
            if (this.lojaAddOrEdit && dados.contato_email) {
              this.cadastro.configuracoes_adicionais.contato_email =
                dados.contato_email;
            }

            //ACESSOS
            if (dados.circus) {
              this.cadastro.acesso.circus = dados.circus;
              this.cadastro.acesso.url_circus = dados.url_circus;
              this.cadastro.acesso.idevento_default = dados.idevento_default;
              this.cadastro.acesso.token_circus = dados.token_circus;
            }

            // CASHLESS
            this.cadastro.cashless.url_cashless = dados.url_cashless;
            this.cadastro.cashless.token_cashless = dados.token_cashless;
          }
        });
    },

    /**
     * @description Função que lista regionais
     */
    getRegionais() {
      this.$axios.post(this.ENDPOINTS.LISTAR_REGIONAIS).then(response => {
        if (response) {
          this.regionais = response;
          this.$axios.setLocal("regionais", response);
        }
      });
    },

    /**
     * @description Função que lista as formas de pagamento
     */
    getFormasDePagamento() {
      this.$axios.post(this.ENDPOINTS.LISTAR_FORMA_PAGAMENTO).then(response => {
        if (response) {
          this.lista_forma_pagamento = response;
          this.$axios.setLocal("lista_forma_pagamento", response);
        }
      });
    },
    getFormasPagLoja(sequenciador) {
      sequenciador = sequenciador
        ? sequenciador
        : store.getters.storeSequencial;
      this.formaPag.formas_pgto_loading = true;
      this.$axios
        .get(this.ENDPOINTS.LISTAR_FORMA_PAG_LOJA + sequenciador)
        .then(response => {
          this.formaPag.formas_pgto_loading = false;
          this.lista_forma_pagamento_loja = response;
        })
        .catch(err => {
          this.formaPag.formas_pgto_loading = false;
          console.error(err);
        });
    },
    getFormasPagLojaDefault() {
      this.formaPag.formas_pgto_loading = true;
      this.$axios
        .get(this.ENDPOINTS.LISTAR_FORMA_PAG_LOJA + "default")
        .then(response => {
          this.formaPag.formas_pgto_loading = false;
          this.lista_forma_pagamento_loja = response;
        })
        .catch(err => {
          this.formaPag.formas_pgto_loading = false;
          console.error(err);
        });
    },

    /**
     * @description Método para deletar uma forma de pagamento
     * @param {String} idforma_pag - ID da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição e chama o método de listagem para atualizar a lista
     */
    deletarFormaPgto(idforma_pag) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_FORMAS_DE_PAGAMENTO + idforma_pag)
        .then(() => this.getFormasPagLoja(store.getters.storeSequencial))
        .catch(error => {
          throw new Error(error);
        });
    },

    async getVendasDiarias(date) {
      return await this.$axios
        .get(
          this.ENDPOINTS.GET_VENDAS_DIARIAS +
            `?date=${date ?? "2024-10-12"} 10:10:10`
        )
        .then(response => {
          if (response) {
            return response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    async getVendasDiariasWE(date) {
      return await this.$axios
        .get(this.ENDPOINTS.GET_VENDAS_DIARIAS_WE + `?data=${date}`)
        .then(response => {
          if (response) {
            return response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    async getAcessosWE(date) {
      return await this.$axios
        .get(this.ENDPOINTS.GET_ACESSOS_WE + `?data=${date}`)
        .then(response => {
          if (response) {
            return response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Método para alterar uma forma de pagamento
     * @param {Object} dados - Dados da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    alterarFormaPgto() {
      this.formaPag.formas_pgto_button_loading = true;
      let dados = {
        ordem: this.formaPag.cadastro.ordem,
        descricao: this.formaPag.cadastro.descricao,
        status: this.formaPag.cadastro.status,
        juros: this.formaPag.cadastro.juros,
        num_parcelas: this.formaPag.cadastro.parcelas,
        tipo: this.formaPag.cadastro.tipo,
        loja: store.getters.storeSequencial,
      };

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_FORMAS_DE_PAGAMENTO +
            this.formaPag.cadastro.idforma_pag,
          dados
        )
        .then(() => {
          this.formaPag.formas_pgto_button_loading = false;
          this.limparFormularioFormasPgto();
        })
        .catch(error => {
          this.formaPag.formas_pgto_button_loading = false;
          throw new Error(error);
        })
        .finally(() => {
          this.formaPag.add_formas = false;
          this.getFormasPagLoja(store.getters.storeSequencial);
        });
    },

    /**
     * @description Método para cadastrar uma nova forma de pagamento
     * @param {Object} dados - Dados da forma de pagamento
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    async cadastrarFormaPgto() {
      this.formaPag.formas_pgto_button_loading = true;
      let dados = {
        ordem: this.formaPag.cadastro.ordem,
        descricao: this.formaPag.cadastro.descricao,
        status: this.formaPag.cadastro.status,
        num_parcelas: this.formaPag.cadastro.parcelas,
        juros: this.formaPag.cadastro.juros,
        tipo: this.formaPag.cadastro.tipo,
        loja: store.getters.storeSequencial,
      };
      await this.$axios
        .post(this.ENDPOINTS.CADASTRAR_FORMAS_DE_PAGAMENTO, dados)
        .then(() => {
          this.formaPag.formas_pgto_button_loading = false;
          this.limparFormularioFormasPgto();
        })
        .catch(() => {
          this.formaPag.formas_pgto_button_loading = false;
        })
        .finally(() => {
          this.formaPag.add_formas = false;
          this.getFormasPagLoja(store.getters.storeSequencial);
        });
    },

    /**
     * @description Método para abrir o modal de confirmação de remoção de formas de pagamento
     * @param {id} String - ID da forma de pagamento
     * @param {msg} String - Mensagem de confirmação
     */
    removerFormaPag(id, msg) {
      this.modalConfirm = true;
      this.formaPag.text = msg;
      this.formaPag.cadastro.idforma_pag = id;
    },

    /**
     * @description Método de confirmação de remoção de forma de pagamento
     */
    funcaoRemoverFormaPag() {
      this.deletarFormaPgto(this.formaPag.cadastro.idforma_pag);
    },
    async validarCadastroFormaPag() {
      if (this.formaPag.cadastro.ordem == "") {
        this.$config.alert(
          "Preencha a ordem corretamente!",
          this.$config.dados.errorColor
        );
        this.formaPag.cadastro.error.ordem = "Preencha a ordem corretamente!";
        return;
      }

      if (this.formaPag.cadastro.descricao == "") {
        this.$config.alert(
          "Preencha a descrição corretamente!",
          this.$config.dados.errorColor
        );
        this.formaPag.cadastro.error.descricao =
          "Preencha a descrição corretamente!";
        return;
      }

      if (this.formaPag.cadastro.status == "") {
        this.$config.alert(
          "Selecione o status da forma de pagamento!",
          this.$config.dados.errorColor
        );
        this.formaPag.cadastro.error.status =
          "Selecione o status da forma de pagamento!";
        return;
      }

      if (this.formaPag.cadastro.tipo == "") {
        this.$config.alert(
          "Selecione o tipo da forma de pagamento!",
          this.$config.dados.errorColor
        );
        this.formaPag.cadastro.error.tipo =
          "Selecione o tipo da forma de pagamento!";
        return;
      }

      if (this.formaPag.formas_pgto_AddEdit == "edit") {
        this.alterarFormaPgto();
        return;
      }

      this.cadastrarFormaPgto();
    },
    /**
     * @description Método para listar as bandeiras aceitas
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getBandeirasAceitas() {
      this.$axios
        .get(this.ENDPOINTS.LISTAR_BANDEIRAS_ACEITAS)
        .then(response => {
          let responseObjects = Object.entries(response);

          responseObjects.forEach(([key, value]) => {
            this.bandeirasPgto.push({ text: value, value: key });
          });
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Função que desabilita uma loja
     */
    alterarStatusLojas(idloja, status) {
      this.$axios
        .put(this.ENDPOINTS.ALTERAR_STATUS_LOJA + idloja + "/" + status)
        .then(() => {
          this.getAllLojas();
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Função que altera uma loja
     */
    alterarLoja(loja, publish) {
      this.cadastro.loading = true;
      let dados = {};
      let banners = {};
      let documentos = {
        pdf_comprovante_endereco: "",
        pdf_contrato_social: "",
        pdf_documento: "",
        pdf_procuracao: "",
        pdf_proposta_comercial: "",
      };

      if (publish) {
        dados.publicar_loja = true;
      }

      this.cadastro.tema.banners_array.forEach(item => {
        banners[Object.keys(item)] = Object.values(item)[0];
      });

      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pj.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pj[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_contrato_social"
            ? (documentos.pdf_contrato_social = element.pdf_contrato_social)
            : "";
          Object.keys(element) == "pdf_documento"
            ? (documentos.pdf_documento = element.pdf_documento)
            : "";
          Object.keys(element) == "pdf_procuracao"
            ? (documentos.pdf_procuracao = element.pdf_procuracao)
            : "";
          Object.keys(element) == "pdf_proposta_comercial"
            ? (documentos.pdf_proposta_comercial =
                element.pdf_proposta_comercial)
            : "";
        }

        dados.dados_cadastrais = {
          // dados da loja
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          nome_loja: this.cadastro.dados_cadastrais.nome_loja,
          slug: this.cadastro.dados_cadastrais.slug_loja,
          tipo_slug: this.cadastro.dados_cadastrais.tipo_slug,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
          idsegmento: this.cadastro.dados_cadastrais.segmento,
          idregional: this.cadastro.dados_cadastrais.regional,
          idagente: this.cadastro.dados_cadastrais.agente_vinculado,
          status: this.cadastro.dados_cadastrais.status,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
          cnpj: this.cadastro.dados_cadastrais.cnpj,
          idloja_neo: this.cadastro.dados_cadastrais.idloja_neo,

          // dados do representante
          representante_nome: this.cadastro.dados_cadastrais.nome,
          representante_cpf: this.cadastro.dados_cadastrais.cpf,
          representante_rg: this.cadastro.dados_cadastrais.rg,
          representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          representante_email: this.cadastro.dados_cadastrais.email,
          marketing_imply_ativo: this.cadastro.tema.marketing_imply_ativo,
        };
      } else {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pf.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pf[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_contrato_social"
            ? (documentos.pdf_contrato_social = element.pdf_contrato_social)
            : "";
          Object.keys(element) == "pdf_documento"
            ? (documentos.pdf_documento = element.pdf_documento)
            : "";
          Object.keys(element) == "pdf_procuracao"
            ? (documentos.pdf_procuracao = element.pdf_procuracao)
            : "";
          Object.keys(element) == "pdf_proposta_comercial"
            ? (documentos.pdf_proposta_comercial =
                element.pdf_proposta_comercial)
            : "";
        }
        dados.dados_cadastrais = {
          // dados da loja
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          nome_loja: this.cadastro.dados_cadastrais.nome_loja,
          slug: this.cadastro.dados_cadastrais.slug_loja,
          tipo_slug: this.cadastro.dados_cadastrais.tipo_slug,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
          idsegmento: this.cadastro.dados_cadastrais.segmento,
          idregional: this.cadastro.dados_cadastrais.regional,
          idagente: this.cadastro.dados_cadastrais.agente_vinculado,
          status: this.cadastro.dados_cadastrais.status,
          idloja_neo: this.cadastro.dados_cadastrais.idloja_neo,

          // dados do representante
          nome: this.cadastro.dados_cadastrais.nome,
          cpf: this.cadastro.dados_cadastrais.cpf,
          rg: this.cadastro.dados_cadastrais.rg,
          rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          email: this.cadastro.dados_cadastrais.email,
          marketing_imply_ativo: this.cadastro.tema.marketing_imply_ativo,
        };
      }
      (dados.dados_cadastrais.celular = this.cadastro.dados_cadastrais.celular),
        (dados.comissao_antecipacao = {
          //DADOS WEB
          // tipo_taxa_web: this.cadastro.comissao_antecipacao.tipoComissaoWeb,
          // comissao_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_web
          //     : "0",
          // taxa_conveniencia_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_web
          //     : "0",
          // comissao_porcentagem_custom_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_web
          //     : "0",
          // taxa_conveniencia_porcentagem_custom_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_web
          //     : "0",

          // //DADOS POS

          // tipo_taxa_pos: this.cadastro.comissao_antecipacao.tipoComissaoPos,
          // comissao_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_pos
          //     : "0",
          // taxa_conveniencia_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_pos
          //     : "0",
          // comissao_porcentagem_custom_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_pos
          //     : "0",
          // taxa_conveniencia_porcentagem_custom_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_pos
          //     : "0",

          // taxa_processamento:
          //   this.cadastro.comissao_antecipacao.taxa_processamento,
          // antecipacao: this.cadastro.comissao_antecipacao.antecipacao,
          // taxa_personalizada: this.cadastro.comissao_antecipacao.taxa_personalizada,
          // dias_antecipacao: this.cadastro.comissao_antecipacao.dias_antecipacao,
          // taxa_mes: this.cadastro.comissao_antecipacao.taxa_mes,
          tipo_taxa_cortesia:
            this.cadastro.comissao_antecipacao.tipoTaxaCortesia,
          taxa_cortesia: this.cadastro.comissao_antecipacao.taxaCortesia,
          taxa_gratuidade: this.cadastro.comissao_antecipacao.taxaGratuidade,
          tipo_taxa_pacote: this.cadastro.comissao_antecipacao.tipoTaxaPacote,
          taxa_pacote: this.cadastro.comissao_antecipacao.taxaPacote,
          aplica_taxa_pacote:
            this.cadastro.comissao_antecipacao.aplicar_taxas_pacote,
          aplica_taxa_cortesia:
            this.cadastro.comissao_antecipacao.aplicar_taxas_cortesia,
          aplica_taxa_gratuidade:
            this.cadastro.comissao_antecipacao.aplicar_taxas_gratuidade,
          observacoes: this.cadastro.comissao_antecipacao.observacoes,
          // aplicar_taxas: this.cadastro.comissao_antecipacao.aplicar_taxas,
        }),
        (dados.dados_bancarios = {
          nome_titular: this.cadastro.dados_bancarios.nome_titular,
          banco: this.cadastro.dados_bancarios.banco,
          agencia: this.cadastro.dados_bancarios.agencia,
          tipo_conta: this.cadastro.dados_bancarios.tipo_conta,
          numero_conta: this.cadastro.dados_bancarios.numero_conta,
          digito_conta: this.cadastro.dados_bancarios.digito_conta,
          bandeiras: this.cadastro.dados_bancarios.bandeiras.join(";"),
        }),
        (dados.documentos = documentos),
        // contratos: {
        //     template: this.cadastro.contratos.template,
        // },
        (dados.tema = {
          cor_primaria: this.cadastro.tema.cor_primaria,
          cor_secundaria: this.cadastro.tema.cor_secundaria,
          banner_link: this.cadastro.tema.banner_link,
          logotipo:
            this.cadastro.tema.logotipo.imagem == null
              ? ""
              : this.cadastro.tema.logotipo.imagem,
          logotipo_pos:
            this.cadastro.tema.logotipo_pos.imagem == null
              ? ""
              : this.cadastro.tema.logotipo_pos.imagem,
          logotipo_ingresso:
            this.cadastro.tema.logotipo_ingresso.imagem == null
              ? ""
              : this.cadastro.tema.logotipo_ingresso.imagem,
          banners: JSON.stringify(banners),
          banner_texto_traducao: this.cadastro.tema.tem_traducao,
          banner_texto: this.cadastro.tema.tem_traducao
            ? `<pt_BR>${this.cadastro.tema.texto_banner}</pt_BR><en_US>${this.cadastro.tema.texto_banner_en}</en_US><es_ES>${this.cadastro.tema.texto_banner_es}</es_ES>`
            : this.cadastro.tema.texto_banner,
        }),
        (dados.configuracoes_rede = {
          validar_cpf: this.cadastro.configuracoes_rede.validar_cpf,
          rede_vendas: this.cadastro.configuracoes_rede.rede_vendas,
          canal_venda:
            this.cadastro.configuracoes_rede.rede_vendas === "PRIVADA"
              ? this.cadastro.configuracoes_rede.rede_privada.join(";")
              : this.cadastro.configuracoes_rede.rede_compartilhada.join(";"),
          canal_venda_descontos: JSON.stringify(
            this.cadastro.configuracoes_rede.canal_venda_descontos
          ),
          // perfis_pdv: this.cadastro.configuracoes_rede.perfis_pdv
        }),
        (dados.configuracoes_adicionais = {
          faq: JSON.stringify(
            this.cadastro.configuracoes_adicionais.perguntas_frequentes
          ),
          redes_sociais: JSON.stringify(
            this.cadastro.configuracoes_adicionais.redes_sociais
          ),
          contato: JSON.stringify(
            this.cadastro.configuracoes_adicionais.contato
          ),
          politicas: JSON.stringify(
            this.cadastro.configuracoes_adicionais.politicas
          ),
          contato_sac: this.cadastro.configuracoes_adicionais.contato_sac,
          contato_email: this.cadastro.configuracoes_adicionais.contato_email,
        });

      let loja_id = publish ? loja : this.cadastro.id_loja;
      if (this.cadastro.dados_bancarios.tipo_forma_pag === "DEFAULT") {
        dados.dados_bancarios.nidforma_pag_default =
          this.cadastro.dados_bancarios.forma_pag.join(";");
        dados.dados_bancarios.nidforma_pag = "";
      } else {
        dados.dados_bancarios.nidforma_pag =
          this.cadastro.dados_bancarios.forma_pag.join(";");
        dados.dados_bancarios.nidforma_pag_default = "";
      }

      dados.acesso = {
        url_circus: this.cadastro.acesso.url_circus,
        token_circus: this.cadastro.acesso.token_circus,
        idevento_default: this.cadastro.acesso.idevento_default,
        circus: this.cadastro.acesso.circus,
      };
      dados.cashless = {
        url_cashless: this.cadastro.cashless.url_cashless,
        token_cashless: this.cadastro.cashless.token_cashless,
      };
      this.$axios
        .put(this.ENDPOINTS.ALTERAR_LOJA + loja_id, dados)
        .then(response => {
          if (
            response.sucesso &&
            this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin"
          ) {
            router.push({ name: "producers" });
            this.$axios.setLocal("confirmEditLoja", true);
            this.limpaFormularioDeLoja();
            this.cadastro.loading = false;
            return;
          }

          if (response.sucesso) {
            this.lojaAddOrEdit = "editar";
            router.push({ name: "home" });
            this.getLoja(this.cadastro.id_loja);
            this.$axios.setLocal("confirmEditLoja", true);
            this.cadastro.loading = false;
            this.$lojas_usuarios.getLogin(
              false,
              "",
              "",
              this.$axios.getLocal("oe_user_info")?.data?.loja,
              this.$axios.getLocal("oe_user_info").data,
              this.$axios.getCookie("token").data
            );
          }
        })
        .catch(() => {
          this.cadastro.loading = false;
        })
        .finally(() => {
          this.cadastro.loading = false;
          store.dispatch("updateCurrentStore");
        });
    },

    /**
     * @description Método para abrir o modal de confirmação de remoção da loja
     * @param {idloja} String - ID da loja
     * @param {msg} String - Mensagem de confirmação
     */
    removerLojaModal(idloja, msg) {
      this.$config.modalConfirm = true;
      this.produtor.text = msg;
      this.cadastro.id_loja = idloja;
    },

    /**
     * @description Função que remove uma loja
     */
    removerLoja(idloja) {
      idloja = this.cadastro.id_loja;

      this.$axios
        .delete(this.ENDPOINTS.REMOVER_LOJA + idloja)
        .then(() => this.getAllLojas())
        .catch(err => console.log(err));
    },

    /**
     * @description Função que cadastra uma loja
     */
    async cadastrarLoja() {
      this.cadastro.loading = true;
      let dados = {};
      let banners = {};
      let documentos = {};

      this.cadastro.tema.banners_array.forEach(item => {
        banners[Object.keys(item)] = Object.values(item)[0];
      });

      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pj.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pj[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_contrato_social"
            ? (documentos.pdf_contrato_social = element.pdf_contrato_social)
            : "";
          Object.keys(element) == "pdf_documento"
            ? (documentos.pdf_documento = element.pdf_documento)
            : "";
          Object.keys(element) == "pdf_procuracao"
            ? (documentos.pdf_procuracao = element.pdf_procuracao)
            : "";
          Object.keys(element) == "pdf_proposta_comercial"
            ? (documentos.pdf_proposta_comercial =
                element.pdf_proposta_comercial)
            : "";
        }

        dados.dados_cadastrais = {
          // dados da loja
          new_idloja: this.cadastro.new_idloja,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          nome_loja: this.cadastro.dados_cadastrais.nome_loja,
          slug: this.cadastro.dados_cadastrais.slug_loja,
          tipo_slug: this.cadastro.dados_cadastrais.tipo_slug,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
          idsegmento: this.cadastro.dados_cadastrais.segmento,
          idregional: this.cadastro.dados_cadastrais.regional,
          idagente: this.cadastro.dados_cadastrais.agente_vinculado,
          status: this.cadastro.dados_cadastrais.status,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
          cnpj: this.cadastro.dados_cadastrais.cnpj,
          idloja_neo: this.cadastro.dados_cadastrais.idloja_neo,

          // dados do representante
          representante_nome: this.cadastro.dados_cadastrais.nome,
          representante_cpf: this.cadastro.dados_cadastrais.cpf,
          representante_rg: this.cadastro.dados_cadastrais.rg,
          representante_rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          representante_email: this.cadastro.dados_cadastrais.email,
          marketing_imply_ativo: this.cadastro.tema.marketing_imply_ativo,
        };
      } else {
        for (
          let index = 0;
          index < this.cadastro.documentos.documento_array_pf.length;
          index++
        ) {
          const element = this.cadastro.documentos.documento_array_pf[index];

          Object.keys(element) == "pdf_comprovante_endereco"
            ? (documentos.pdf_comprovante_endereco =
                element.pdf_comprovante_endereco)
            : "";
          Object.keys(element) == "pdf_contrato_social"
            ? (documentos.pdf_contrato_social = element.pdf_contrato_social)
            : "";
          Object.keys(element) == "pdf_documento"
            ? (documentos.pdf_documento = element.pdf_documento)
            : "";
          Object.keys(element) == "pdf_procuracao"
            ? (documentos.pdf_procuracao = element.pdf_procuracao)
            : "";
          Object.keys(element) == "pdf_proposta_comercial"
            ? (documentos.pdf_proposta_comercial =
                element.pdf_proposta_comercial)
            : "";
        }
        dados.dados_cadastrais = {
          // dados da loja
          new_idloja: this.cadastro.new_idloja,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          nome_loja: this.cadastro.dados_cadastrais.nome_loja,
          slug: this.cadastro.dados_cadastrais.slug_loja,
          tipo_slug: this.cadastro.dados_cadastrais.tipo_slug,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_cep: this.cadastro.dados_cadastrais.cep,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_complemento: this.cadastro.dados_cadastrais.complemento,
          idsegmento: this.cadastro.dados_cadastrais.segmento,
          idregional: this.cadastro.dados_cadastrais.regional,
          idagente: this.cadastro.dados_cadastrais.agente_vinculado,
          status: this.cadastro.dados_cadastrais.status,
          idloja_neo: this.cadastro.dados_cadastrais.idloja_neo,

          // dados do representante
          nome: this.cadastro.dados_cadastrais.nome,
          cpf: this.cadastro.dados_cadastrais.cpf,
          rg: this.cadastro.dados_cadastrais.rg,
          rg_orgao: this.cadastro.dados_cadastrais.rg_orgao,
          email: this.cadastro.dados_cadastrais.email,
          marketing_imply_ativo: this.cadastro.tema.marketing_imply_ativo,
          // idtema: '',
          // idcontrato_odt: this.cadastro.documentos.procuracao,
        };
      }
      (dados.dados_cadastrais.celular = this.cadastro.dados_cadastrais.celular),
        (dados.comissao_antecipacao = {
          // tipo_taxa_web: this.cadastro.comissao_antecipacao.tipoComissaoWeb,
          // comissao_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_web
          //     : "0",
          // taxa_conveniencia_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_web
          //     : "0",
          // comissao_porcentagem_custom_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_web
          //     : "0",
          // taxa_conveniencia_porcentagem_custom_web:
          //   this.cadastro.comissao_antecipacao.tipoComissaoWeb ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaWeb === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_web
          //     : "0",

          // tipo_taxa_pos: this.cadastro.comissao_antecipacao.tipoComissaoPos,
          // comissao_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_pos
          //     : "0",
          // taxa_conveniencia_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "VALOR"
          //     ? this.cadastro.comissao_antecipacao.valor_taxa_pos
          //     : "0",
          // comissao_porcentagem_custom_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos === "COMISSAO" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_pos
          //     : "0",
          // taxa_conveniencia_porcentagem_custom_pos:
          //   this.cadastro.comissao_antecipacao.tipoComissaoPos ===
          //     "CONVENIENCIA" &&
          //   this.cadastro.comissao_antecipacao.tipoTaxaPos === "PERCENTUAL"
          //     ? this.cadastro.comissao_antecipacao.percentual_taxa_pos
          //     : "0",
          // taxa_processamento:
          //   this.cadastro.comissao_antecipacao.taxa_processamento,
          tipo_taxa_cortesia:
            this.cadastro.comissao_antecipacao.tipoTaxaCortesia,
          taxa_cortesia:
            this.cadastro.comissao_antecipacao.aplicar_taxas_cortesia == 0
              ? ""
              : this.cadastro.comissao_antecipacao.taxaCortesia,
          taxa_gratuidade:
            this.cadastro.comissao_antecipacao.aplicar_taxas_gratuidade == 0
              ? ""
              : this.cadastro.comissao_antecipacao.taxaGratuidade,
          tipo_taxa_pacote: this.cadastro.comissao_antecipacao.tipoTaxaPacote,
          taxa_pacote:
            this.cadastro.comissao_antecipacao.aplicar_taxas_pacote == 0
              ? ""
              : this.cadastro.comissao_antecipacao.taxaPacote,
          aplica_taxa_pacote:
            this.cadastro.comissao_antecipacao.aplicar_taxas_pacote,
          aplica_taxa_cortesia:
            this.cadastro.comissao_antecipacao.aplicar_taxas_cortesia,
          aplica_taxa_gratuidade:
            this.cadastro.comissao_antecipacao.aplicar_taxas_gratuidade,
          observacoes: this.cadastro.comissao_antecipacao.observacoes,
        }),
        (dados.dados_bancarios = {
          nome_titular: this.cadastro.dados_bancarios.nome_titular,
          banco: this.cadastro.dados_bancarios.banco,
          agencia: this.cadastro.dados_bancarios.agencia,
          tipo_conta: this.cadastro.dados_bancarios.tipo_conta,
          numero_conta: this.cadastro.dados_bancarios.numero_conta,
          digito_conta: this.cadastro.dados_bancarios.digito_conta,
          nidforma_pag_default:
            this.cadastro.dados_bancarios.forma_pag.length > 0
              ? this.cadastro.dados_bancarios.forma_pag.join(";")
              : "",
          bandeiras: this.cadastro.dados_bancarios.bandeiras.join(";"),
        }),
        (dados.documentos = documentos),
        // contratos: {
        //     template: this.cadastro.contratos.template,
        // },
        (dados.tema = {
          banner_link: this.cadastro.tema.banner_link,
          cor_primaria: this.cadastro.tema.cor_primaria,
          cor_secundaria: this.cadastro.tema.cor_secundaria,
          logotipo: this.cadastro.tema.logotipo.imagem,
          logotipo_pos:
            this.cadastro.tema.logotipo_pos.imagem == []
              ? ""
              : this.cadastro.tema.logotipo_pos.imagem,
          logotipo_ingresso:
            this.cadastro.tema.logotipo_ingresso.imagem == []
              ? ""
              : this.cadastro.tema.logotipo_ingresso.imagem,
          banners: JSON.stringify(banners),
          banner_texto_traducao: this.cadastro.tema.tem_traducao,
          banner_texto: this.cadastro.tema.tem_traducao
            ? `<pt_BR>${this.cadastro.tema.texto_banner}</pt_BR><en_US>${this.cadastro.tema.texto_banner_en}</en_US><es_ES>${this.cadastro.tema.texto_banner_es}</es_ES>`
            : this.cadastro.tema.texto_banner,
        }),
        (dados.configuracoes_rede = {
          validar_cpf: this.cadastro.configuracoes_rede.validar_cpf,
          rede_vendas: this.cadastro.configuracoes_rede.rede_vendas,
          canal_venda:
            this.cadastro.configuracoes_rede.rede_vendas === "PRIVADA"
              ? this.cadastro.configuracoes_rede.rede_privada.join(";")
              : this.cadastro.configuracoes_rede.rede_compartilhada.join(";"),
          canal_venda_descontos: JSON.stringify(
            this.cadastro.configuracoes_rede.canal_venda_descontos
          ),
          // perfis_pdv: this.cadastro.configuracoes_rede.perfis_pdv
        }),
        (dados.configuracoes_adicionais = {
          faq: JSON.stringify(
            this.cadastro.configuracoes_adicionais.perguntas_frequentes
          ),
          redes_sociais: JSON.stringify(
            this.cadastro.configuracoes_adicionais.redes_sociais
          ),
          contato: JSON.stringify(
            this.cadastro.configuracoes_adicionais.contato
          ),
          politicas: JSON.stringify(
            this.cadastro.configuracoes_adicionais.politicas
          ),
          contato_sac: this.cadastro.configuracoes_adicionais.contato_sac,
          contato_email: this.cadastro.configuracoes_adicionais.contato_email,
        });

      dados.acesso = {
        url_circus: this.cadastro.acesso.url_circus,
        token_circus: this.cadastro.acesso.token_circus,
        idevento_default: this.cadastro.acesso.idevento_default,
        circus: this.cadastro.acesso.circus,
      };
      dados.cashless = {
        url_cashless: this.cadastro.cashless.url_cashless,
        token_cashless: this.cadastro.cashless.token_cashless,
      };
      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_LOJA, JSON.stringify(dados))
        .then(response => {
          if (response.sucesso) {
            router.push({
              name: "producers",
            });
            this.limpaFormularioDeLoja();
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description Função que filtra lojas
     */
    filtroLojas() {
      this.filtros = [];

      function formatDate(date) {
        const dateParts = date.split("/");
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        return formattedDate;
      }

      if (this.filter.nome != "") {
        this.filtros.push({
          campo: "loja.nome_loja",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nome,
        });
      }
      if (this.filter.cpf != "" && this.filter.cpf != null) {
        this.filtros.push({
          campo: "loja.cpf",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.cpf,
        });
      }

      if (this.filter.cnpj != "" && this.filter.cnpj != null) {
        this.filtros.push({
          campo: "loja.cnpj",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.cnpj,
        });
      }

      if (this.filter.status != "" && this.filter.status != null) {
        this.filtros.push({
          campo: "loja.status",
          tipo: "string",
          orientacao: "=",
          valor: this.filter.status,
        });
      }

      if (this.filter.dataInicio != "") {
        this.filtros.push({
          campo: "loja.ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: formatDate(this.filter.dataInicio) + " 00:00",
        });
      }

      if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "loja.ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: formatDate(this.filter.dataFim) + " 23:59",
        });
      }

      if (this.filter.regional != "" && this.filter.regional != null) {
        this.filtros.push({
          campo: "loja.idregional",
          tipo: "string",
          valor: this.filter.regional,
        });
      }

      if (this.filter.tipoPessoa != "" && this.filter.tipoPessoa != null) {
        this.filtros.push({
          campo: "loja.tipo_pessoa",
          tipo: "string",
          orientacao: "=",
          valor: this.filter.tipoPessoa,
        });
      }

      let filtered = this.filtros;
      this.cadastro.lojas_loading = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_LOJAS,
          JSON.stringify({ filtros: filtered })
        )
        .then(response => {
          this.lojas = response;
          this.cadastro.lojas_loading = false;
        });
    },

    validarImagem(file) {
      const img = new Image();
      img.src = window.URL.createObjectURL(file);

      return new Promise(resolve => {
        img.onload = () => {
          resolve(img.width > 780 && img.height > 260);
        };
      });
    },

    async validarCadastro(type) {
      if (this.cadastro.dados_cadastrais.pessoa === "FISICA") {
        if (this.cadastro.tema.logotipo_pos.object) {
          if (this.cadastro.tema.logotipo_pos.object) {
            const valida = await this.validarImagem(
              this.cadastro.tema.logotipo_pos.object
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.logotipo_pos = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }

        if (this.cadastro.tema.logotipo.object) {
          if (this.cadastro.tema.logotipo.object) {
            const valida = await this.validarImagem(
              this.cadastro.tema.logotipo.object
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.imagem_logo = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }

        if (this.cadastro.tema.logotipo_ingresso.object) {
          if (this.cadastro.tema.logotipo_ingresso.object) {
            const valida = await this.validarImagem(
              this.cadastro.tema.logotipo_ingresso.object
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.logotipo_ingresso = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }

        if (
          (this.cadastro.tema.imagem_upload.object,
          this.cadastro.tema.imagem_upload.imagem)
        ) {
          if (
            (this.cadastro.tema.imagem_upload.object,
            this.cadastro.tema.imagem_upload.imagem)
          ) {
            const valida = await this.validarImagem(
              this.cadastro.tema.imagem_upload.object,
              this.cadastro.tema.imagem_upload.imagem
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.logotipo = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }

        /**
         * @description Bloco de validação para os dados de configurações de rede de vendas
         */
        if (this.cadastro.configuracoes_rede.rede_vendas === "PRIVADA") {
          if (this.cadastro.configuracoes_rede.rede_privada.length <= 0) {
            this.$config.alert(
              i18n.t("registrations.producers.sales-channel-error"),
              this.$config.dados.errorColor
            );
            return;
          }
        } else {
          if (this.cadastro.configuracoes_rede.rede_compartilhada.length <= 0) {
            this.$config.alert(
              i18n.t("registrations.producers.sales-channel-error"),
              this.$config.dados.errorColor
            );
            return;
          }
        }
        /**
         * @description Bloco que verifica se é edição ou criação de loja
         */
        if (type === "editar") {
          this.alterarLoja("", false);
          return;
        }
        this.cadastrarLoja();
      }

      /**
       * @description Bloco que trata dados cadastrais para pessoa jurídica
       */
      if (this.cadastro.dados_cadastrais.pessoa === "JURIDICA") {
        /**
         * @description Bloco de validação para os documentos
         */
        /**
         * @description Bloco de validação para os dados de tema da loja
         */
        if (this.cadastro.tema.logotipo_pos.object) {
          if (this.cadastro.tema.logotipo_pos.object) {
            const valida = await this.validarImagem(
              this.cadastro.tema.logotipo_pos.object
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.logotipo_pos = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }

        if (this.cadastro.tema.logotipo_ingresso.object) {
          if (this.cadastro.tema.logotipo_ingresso.object) {
            const valida = await this.validarImagem(
              this.cadastro.tema.logotipo_ingresso.object
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.logotipo_ingresso = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }

        if (this.cadastro.tema.logotipo.object) {
          if (this.cadastro.tema.logotipo.object) {
            const valida = await this.validarImagem(
              this.cadastro.tema.logotipo.object
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.imagem_logo = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }

        if (this.cadastro.tema.imagem_upload.object) {
          if (this.cadastro.tema.imagem_upload.object) {
            const valida = await this.validarImagem(
              this.cadastro.tema.imagem_upload.object
            );
            if (valida) {
              this.$config.alert(
                i18n.t("registrations.producers.image-dimensions-error"),
                this.$config.dados.errorColor
              );
              this.cadastro.tema.error.logotipo = i18n.t(
                "registrations.producers.image-dimensions-error"
              );
              return;
            }
          }
        }
        /**
         * @description Bloco de validação para os dados de configurações de rede de vendas
         */
        if (this.cadastro.configuracoes_rede.rede_vendas === "PRIVADA") {
          if (this.cadastro.configuracoes_rede.rede_privada.length <= 0) {
            this.$config.alert(
              i18n.t("registrations.producers.sales-channel-error"),
              this.$config.dados.errorColor
            );
            return;
          }
        } else {
          if (this.cadastro.configuracoes_rede.rede_compartilhada.length <= 0) {
            this.$config.alert(
              i18n.t("registrations.producers.sales-channel-error"),
              this.$config.dados.errorColor
            );
            return;
          }
        }

        /**
         * @description Bloco que verifica se é edição ou criação de loja
         */
        if (type === "editar") {
          this.alterarLoja("", false);
          return;
        }
        this.cadastrarLoja();
      }
    },

    /**
     * @description Função que abre modal para confirmar remoção das configs adicionais
     */
    remover(index, type, name, msg) {
      this.text = msg;
      this.funcao = type;
      this.indexValue = index;
      this.indexImageOrDoc = index;
      this.valueImageOrDoc = name;
      this.$config.modalConfirm = true;
    },

    /**
     * @description Função que confirma a remoção das configs adicionais
     */
    funcaoRemover(funcao) {
      switch (funcao) {
        case "question":
          this.cadastro.configuracoes_adicionais.perguntas_frequentes.splice(
            this.indexValue,
            1
          );
          break;
        case "social":
          this.cadastro.configuracoes_adicionais.redes_sociais.splice(
            this.indexValue,
            1
          );
          break;
        case "contact":
          this.cadastro.configuracoes_adicionais.contato.splice(
            this.indexValue,
            1
          );
          break;
        case "policy":
          this.cadastro.configuracoes_adicionais.politicas.splice(
            this.indexValue,
            1
          );
          break;
        case "image":
          this.removeImage(this.indexImageOrDoc, this.valueImageOrDoc);
          break;
        case "document":
          this.removeDOC(this.indexImageOrDoc, this.valueImageOrDoc);
          break;
        default:
          break;
      }
    },

    /**
     * @description Função que remove a imagem da loja
     */
    removeImage(index, i) {
      this.cadastro.tema.banners_array.splice(index, 1);
      let tipo = this.tipo_imagem.find(item => item.value === i);
      if (tipo) {
        tipo.show = true;
      }
    },

    /**
     * @description Função que remove a documento da loja
     */
    removeDOC(index, i) {
      if (this.cadastro.dados_cadastrais.pessoa == "FISICA") {
        this.cadastro.documentos.documento_array_pf.splice(index, 1);
        let tipo = this.tipo_docs_pf.find(item => item.value === i);
        if (tipo) {
          tipo.show = true;
        }
      } else {
        this.cadastro.documentos.documento_array_pj.splice(index, 1);
        let tipo = this.tipo_docs_pj.find(item => item.value === i);
        if (tipo) {
          tipo.show = true;
        }
      }
    },

    /**
     * @description Função que abre modal para adicionar configs adicionais
     */
    openModal(name, type, table, data, idx) {
      document.getElementsByClassName(name)[0].style.display = "flex";
      this.cadastro.configuracoes_adicionais.configsPlusAddEdit = type;

      switch (table) {
        case "question":
          if (data) {
            this.question.ordem = data.ordem;

            let perguntaBR = [];
            let respostaBR = [];
            let perguntaEN = [];
            let respostaEN = [];
            let perguntaES = [];
            let respostaES = [];

            perguntaBR.push(data.pergunta.indexOf("<pt_BR>"));
            perguntaBR.push(data.pergunta.indexOf("</pt_BR>"));
            respostaBR.push(data.resposta.indexOf("<pt_BR>"));
            respostaBR.push(data.resposta.indexOf("</pt_BR>"));
            this.question.pergunta_pt_BR = data.pergunta.substring(
              perguntaBR[0] + 7,
              perguntaBR[1]
            );
            this.question.resposta_pt_BR = data.resposta.substring(
              respostaBR[0] + 7,
              respostaBR[1]
            );

            perguntaEN.push(data.pergunta.indexOf("<en_US>"));
            perguntaEN.push(data.pergunta.indexOf("</en_US>"));
            respostaEN.push(data.resposta.indexOf("<en_US>"));
            respostaEN.push(data.resposta.indexOf("</en_US>"));
            this.question.pergunta_en_US = data.pergunta.substring(
              perguntaEN[0] + 7,
              perguntaEN[1]
            );
            this.question.resposta_en_US = data.resposta.substring(
              respostaEN[0] + 7,
              respostaEN[1]
            );

            perguntaES.push(data.pergunta.indexOf("<es_ES>"));
            perguntaES.push(data.pergunta.indexOf("</es_ES>"));
            respostaES.push(data.resposta.indexOf("<es_ES>"));
            respostaES.push(data.resposta.indexOf("</es_ES>"));
            this.question.pergunta_es_ES = data.pergunta.substring(
              perguntaES[0] + 7,
              perguntaES[1]
            );
            this.question.resposta_es_ES = data.resposta.substring(
              respostaES[0] + 7,
              respostaES[1]
            );

            this.questionIdx = idx;
          }
          return;
        case "social":
          this.social_media.ordem = data.ordem;
          this.social_media.descricao = data.titulo;
          this.social_media.valor = data.valor;
          this.social_mediaIdx = idx;
          return;
        case "contact":
          this.contato.ordem = data.ordem;
          this.contato.descricao = data.titulo;
          this.contato.texto = data.valor;
          this.contatoIdx = idx;
          return;
        case "policy":
          this.politica.descricao_pt_BR = data.titulo.substring(
            data.titulo.indexOf("<pt_BR>") + 7,
            data.titulo.indexOf("</pt_BR>")
          );
          this.politica.descricao_en_US = data.titulo.substring(
            data.titulo.indexOf("<en_US>") + 7,
            data.titulo.indexOf("</en_US>")
          );
          this.politica.descricao_es_ES = data.titulo.substring(
            data.titulo.indexOf("<es_ES>") + 7,
            data.titulo.indexOf("</es_ES>")
          );

          this.politica.texto_pt_BR = data.valor.substring(
            data.valor.indexOf("<pt_BR>") + 7,
            data.valor.indexOf("</pt_BR>")
          );
          this.politica.texto_en_US = data.valor.substring(
            data.valor.indexOf("<en_US>") + 7,
            data.valor.indexOf("</en_US>")
          );
          this.politica.texto_es_ES = data.valor.substring(
            data.valor.indexOf("<es_ES>") + 7,
            data.valor.indexOf("</es_ES>")
          );

          this.politica.tem_traducao = data.tem_traducao;
          this.politicaIdx = idx;
          return;
        default:
          "teste";
          return;
      }
    },

    syncCircus(sequenciador) {
      this.cadastro.acesso.loading_sync = true;
      this.$axios
        .post(`${this.ENDPOINTS.SINCRONIZAR_CIRCUS}/${sequenciador}`)
        .then(() => {
          this.cadastro.acesso.loading_sync = false;
        })
        .catch(() => {
          this.cadastro.acesso.loading_sync = false;
        });
    },
    async syncCircusAll(sequenciador) {
      this.cadastro.acesso.loading_sync_all = true;
      await this.$axios
        .post(`${this.ENDPOINTS.SINCRONIZAR_CIRCUS}/${sequenciador}`, {
          all: true,
        })
        .then(() => {
          this.cadastro.acesso.loading_sync_all = false;
        })
        .catch(() => {
          this.cadastro.acesso.loading_sync_all = false;
        });
    },

    limpaFormularioDeLoja() {
      // dados cadastrais
      this.cadastro.dados_cadastrais.pessoa = "JURIDICA";
      this.cadastro.dados_cadastrais.razao_social = "";
      this.cadastro.dados_cadastrais.cnpj = "";
      this.cadastro.dados_cadastrais.cep = "";
      this.cadastro.dados_cadastrais.logradouro = "";
      this.cadastro.dados_cadastrais.complemento = "";
      this.cadastro.dados_cadastrais.bairro = "";
      this.cadastro.dados_cadastrais.estado = "";
      this.cadastro.dados_cadastrais.cidade = "";
      this.cadastro.dados_cadastrais.pais = "";
      this.cadastro.dados_cadastrais.email = "";
      this.cadastro.dados_cadastrais.nome = "";
      this.cadastro.dados_cadastrais.cpf = "";
      this.cadastro.dados_cadastrais.rg = "";
      this.cadastro.dados_cadastrais.rg_orgao = "";
      this.cadastro.dados_cadastrais.celular = "";
      this.cadastro.dados_cadastrais.segmento = "";
      this.cadastro.dados_cadastrais.regional = "";
      this.cadastro.dados_cadastrais.agente_vinculado = "";
      this.cadastro.dados_cadastrais.status = "";
      this.cadastro.dados_cadastrais.nome_loja = "";
      this.cadastro.dados_cadastrais.slug_loja = "";
      this.cadastro.dados_cadastrais.tipo_slug = "DEFAULT";
      this.cadastro.dados_cadastrais.idloja_neo = "";
      this.cadastro.dados_cadastrais.error.razao_social = [];
      this.cadastro.dados_cadastrais.error.cnpj = [];
      this.cadastro.dados_cadastrais.error.nome_loja = [];
      this.cadastro.dados_cadastrais.error.cep = [];
      this.cadastro.dados_cadastrais.error.pais = [];
      this.cadastro.dados_cadastrais.error.estado = [];
      this.cadastro.dados_cadastrais.error.cidade = [];
      this.cadastro.dados_cadastrais.error.bairro = [];
      this.cadastro.dados_cadastrais.error.logradouro = [];
      this.cadastro.dados_cadastrais.error.segmento = [];
      this.cadastro.dados_cadastrais.error.regional = [];
      this.cadastro.dados_cadastrais.error.status = [];
      this.cadastro.dados_cadastrais.error.slug_loja = [];
      this.cadastro.dados_cadastrais.error.nome = [];
      this.cadastro.dados_cadastrais.error.cpf = [];
      this.cadastro.dados_cadastrais.error.rg = [];
      this.cadastro.dados_cadastrais.error.rg_orgao = [];
      this.cadastro.dados_cadastrais.error.email = [];
      this.cadastro.dados_cadastrais.error.celular = [];

      // comissao_antecipacao
      this.cadastro.comissao_antecipacao.comissao = "7.4";
      this.cadastro.comissao_antecipacao.porcentagem_customizada = "";
      this.cadastro.comissao_antecipacao.antecipacao = "";
      // this.cadastro.comissao_antecipacao.taxa_processamento = "";
      // this.cadastro.comissao_antecipacao.onProcessamento = false;
      this.cadastro.comissao_antecipacao.aplicar_taxas_pacote = 0;
      this.cadastro.comissao_antecipacao.aplicar_taxas_cortesia = 0;
      this.cadastro.comissao_antecipacao.aplicar_taxas_gratuidade = 0;
      this.cadastro.comissao_antecipacao.taxa_personalizada = "";
      this.cadastro.comissao_antecipacao.dias_antecipacao = "";
      this.cadastro.comissao_antecipacao.taxa_mes = "";
      this.cadastro.comissao_antecipacao.observacoes = "";
      // this.cadastro.comissao_antecipacao.valor_taxa_web = "";
      // this.cadastro.comissao_antecipacao.percentual_taxa_web = "10";
      // this.cadastro.comissao_antecipacao.tipoComissaoWeb = "CONVENIENCIA";
      // this.cadastro.comissao_antecipacao.tipoComissaoPos = "COMISSAO";
      // this.cadastro.comissao_antecipacao.tipoTaxaPos = "PERCENTUAL";
      // this.cadastro.comissao_antecipacao.percentual_taxa_pos = "7.4";
      // this.cadastro.comissao_antecipacao.valor_taxa_pos = "";
      this.cadastro.comissao_antecipacao.tipoTaxaCortesia = "VALOR";
      this.cadastro.comissao_antecipacao.taxaCortesia = "0";
      this.cadastro.comissao_antecipacao.taxaGratuidade = "0";
      this.cadastro.comissao_antecipacao.tipoTaxaPacote = "VALOR";
      this.cadastro.comissao_antecipacao.taxaPacote = "0";

      // dados_bancarios
      this.cadastro.dados_bancarios.nome_titular = "";
      this.cadastro.dados_bancarios.banco = "";
      this.cadastro.dados_bancarios.agencia = "";
      this.cadastro.dados_bancarios.tipo_conta = "CORRENTE";
      this.cadastro.dados_bancarios.numero_conta = "";
      this.cadastro.dados_bancarios.digito_conta = "";
      this.cadastro.dados_bancarios.num_parcelas = "";
      this.cadastro.dados_bancarios.forma_pag = "";

      this.cadastro.dados_bancarios.error.nome_titular = [];
      this.cadastro.dados_bancarios.error.banco = [];
      this.cadastro.dados_bancarios.error.agencia = [];
      this.cadastro.dados_bancarios.error.numero_conta = [];
      this.cadastro.dados_bancarios.error.digito_conta = [];
      this.cadastro.dados_bancarios.error.num_parcelas = [];
      this.cadastro.dados_bancarios.error.forma_pag = [];

      // documentos
      this.cadastro.documentos.documento = [];
      this.cadastro.documentos.documento_upload = { doc: null };
      this.cadastro.documentos.loading_documento = false;
      this.cadastro.documentos.documento_array_pj = [];
      this.cadastro.documentos.documento_array_pf = [];
      this.tipo_docs_pf = [
        {
          key: "Comprovante de Endereço ",
          value: "pdf_comprovante_endereco",
          show: true,
        },
        {
          key: "Documento (RG, CPF ou CNH)",
          value: "pdf_documento",
          show: true,
        },
        {
          key: "Proposta Comercial ",
          value: "pdf_proposta_comercial",
          show: true,
        },
      ];
      this.tipo_docs_pj = [
        {
          key: "Comprovante de Endereço ",
          value: "pdf_comprovante_endereco",
          show: true,
        },
        { key: "Contrato Social", value: "pdf_contrato_social", show: true },
        { key: "Procuração", value: "pdf_procuracao", show: true },
        {
          key: "Proposta Comercial ",
          value: "pdf_proposta_comercial",
          show: true,
        },
      ];

      // tema
      this.cadastro.tema.banner_link = "";
      this.cadastro.tema.cor_primaria = "#2D1A4C";
      this.cadastro.tema.cor_secundaria = "#2D1A4C";
      this.cadastro.tema.marketing_imply_ativo = false;
      // this.cadastro.tema.logotipo = { imagem: null, have: false };
      // this.cadastro.tema.logotipo_ingresso = { imagem: null, have: false };
      this.cadastro.tema.imagem = "";
      this.cadastro.tema.imagem_upload = { imagem: null };
      this.cadastro.tema.loading_imagem = false;
      this.cadastro.tema.banners_array = [];
      this.cadastro.tema.texto_banner = "";
      this.cadastro.tema.texto_banner_en = "";
      this.cadastro.tema.texto_banner_es = "";
      this.cadastro.tema.tem_traducao = false;
      this.tipo_imagem = [
        { key: "Banner Rodapé", value: "banner_rodape", show: true },
      ];

      // configuracoes_rede
      this.cadastro.configuracoes_rede.rede_vendas = "COMPARTILHADA";
      this.cadastro.configuracoes_rede.validar_cpf = true;

      this.cadastro.configuracoes_rede.rede_privada = [];
      this.cadastro.configuracoes_rede.rede_compartilhada = [];
      this.cadastro.configuracoes_rede.perfis_pdv = "";
      this.cadastro.configuracoes_rede.canal_venda_descontos = {};

      // configuracoes_adicionais
      this.cadastro.configuracoes_adicionais.configsPlusAddEdit = "new";
      this.cadastro.configuracoes_adicionais.perguntas_frequentes = [];
      this.cadastro.configuracoes_adicionais.redes_sociais = [];
      this.cadastro.configuracoes_adicionais.contato = [];
      this.cadastro.configuracoes_adicionais.politicas = [];
      this.cadastro.configuracoes_adicionais.contato_sac = "";
      this.cadastro.configuracoes_adicionais.contato_email = "";

      // acessos
      this.cadastro.acesso.circus = false;
      this.cadastro.acesso.url_circus = "";
      this.cadastro.acesso.token_circus = "";
      this.cadastro.acesso.idevento_default = "";
      this.cadastro.acesso.error.url_circus = [];
      this.cadastro.acesso.error.token_circus = [];
      this.cadastro.acesso.error.idevento_default = [];

      // cashless
      this.cadastro.cashless.url_cashless = "";
      this.cadastro.cashless.token_cashless = "";
    },
    limpaFiltros() {
      this.filter.nome = "";
      this.filter.cpf = "";
      this.filter.status = "";
      this.filter.regional = "";
      this.filter.tipoPessoa = "";
      this.filter.dataInicio = "";
      this.filter.dataFim = "";
      this.lojas = [];
    },
    limparFormularioFormasPgto() {
      this.formaPag.cadastro.idforma_pag = "";
      this.formaPag.cadastro.ordem = "";
      this.formaPag.cadastro.descricao = "";
      this.formaPag.cadastro.status = "";
      this.formaPag.cadastro.juros = "";
      this.formaPag.cadastro.parcelas = "";
      this.formaPag.cadastro.tipo = "";
      this.formaPag.cadastro.error.descricao = [];
      this.formaPag.cadastro.error.ordem = [];
      this.formaPag.cadastro.error.status = [];
      this.formaPag.cadastro.error.tipo = [];
    },
  },
});
